import { Notyf } from 'notyf'

const notyf = new Notyf({
  duration: 5000,
  types: [
    {
      type: 'success',
      background: '#15803d',
    },
    {
      type: 'error',
      background: '#DB3232',
    },
  ],
})

export function useNotify () {
  return {
    success (text) {
      notyf.success(text)
    },
    error (text) {
      notyf.error(text)
    },
  }
}
